import React, { useState } from 'react';
import { X, Edit, Copy, Archive, ExternalLink, Eye } from 'lucide-react';
import { Chart } from '../components/Chart';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/Tabs';
interface SecondClickOfferDetailProps {
  offer: any;
  onClose: () => void;
  onEdit: () => void;
  onClone: () => void;
  onArchive: () => void;
}
export const SecondClickOfferDetail: React.FC<SecondClickOfferDetailProps> = ({
  offer,
  onClose,
  onEdit,
  onClone,
  onArchive
}) => {
  const [activeTab, setActiveTab] = useState('overview');
  const [period, setPeriod] = useState('7d');
  const handleTestClick = () => {
    alert(`Simulated second-click offer trigger: ${offer.name}`);
  };
  const handlePreview = () => {
    window.open(offer.creative.imageUrl, '_blank');
  };
  // Prepare chart data for segments
  const segmentPerformanceData = Object.entries(offer.performance.segmentPerformance).map(([key, value]: [string, any]) => ({
    name: key.charAt(0).toUpperCase() + key.slice(1).replace('_', ' '),
    cr: value.cr * 100,
    rpm: value.rpm,
    attachRate: value.attachRate * 100
  }));
  return <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden" data-id="element-11622">
      <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50 flex justify-between items-center" data-id="element-11623">
        <h2 className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-11624">
          {offer.name}
        </h2>
        <button onClick={onClose} className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300" data-id="element-11625">
          <X size={20} data-id="element-11626" />
        </button>
      </div>
      <div className="p-6" data-id="element-11627">
        <div className="flex justify-between items-center mb-6" data-id="element-11628">
          <div className="flex space-x-3" data-id="element-11629">
            <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${offer.status === 'active' ? 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-400' : 'bg-gray-100 text-gray-800 dark:bg-gray-900/20 dark:text-gray-400'}`} data-id="element-11630">
              {offer.status === 'active' ? 'Active' : 'Inactive'}
            </span>
            <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${offer.offerSource.type === 'internal' ? 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-400' : 'bg-orange-100 text-orange-800 dark:bg-orange-900/20 dark:text-orange-400'}`} data-id="element-11631">
              {offer.offerSource.type === 'internal' ? 'Internal' : 'External'}
            </span>
          </div>
          <div className="flex space-x-2" data-id="element-11632">
            <select className="px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-md text-sm" value={period} onChange={e => setPeriod(e.target.value)} data-id="element-11633">
              <option value="today" data-id="element-11634">Today</option>
              <option value="yesterday" data-id="element-11635">Yesterday</option>
              <option value="7d" data-id="element-11636">Last 7 days</option>
              <option value="30d" data-id="element-11637">Last 30 days</option>
              <option value="90d" data-id="element-11638">Last 90 days</option>
            </select>
            <button onClick={onEdit} className="px-3 py-2 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 transition-colors flex items-center" data-id="element-11639">
              <Edit size={16} className="mr-2" data-id="element-11640" />
              Edit
            </button>
            <button onClick={onClone} className="px-3 py-2 bg-green-600 text-white rounded-md text-sm hover:bg-green-700 transition-colors flex items-center" data-id="element-11641">
              <Copy size={16} className="mr-2" data-id="element-11642" />
              Clone
            </button>
            <button onClick={onArchive} className="px-3 py-2 bg-red-600 text-white rounded-md text-sm hover:bg-red-700 transition-colors flex items-center" data-id="element-11643">
              <Archive size={16} className="mr-2" data-id="element-11644" />
              Archive
            </button>
          </div>
        </div>
        <div className="mb-6" data-id="element-11645">
          <Tabs defaultValue="overview" data-id="element-11646">
            <TabsList data-id="element-11647">
              <TabsTrigger value="overview" data-id="element-11648">Overview</TabsTrigger>
              <TabsTrigger value="performance" data-id="element-11649">Performance</TabsTrigger>
              <TabsTrigger value="segments" data-id="element-11650">Segment Analysis</TabsTrigger>
              <TabsTrigger value="creative" data-id="element-11651">Creative</TabsTrigger>
              <TabsTrigger value="settings" data-id="element-11652">Settings</TabsTrigger>
            </TabsList>
            <TabsContent value="overview" className="pt-6" data-id="element-11653">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-11654">
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-5" data-id="element-11655">
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-11656">
                    Offer Details
                  </h3>
                  <div className="space-y-4" data-id="element-11657">
                    <div data-id="element-11658">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11659">
                        Trigger Type
                      </h4>
                      <p className="mt-1 text-sm text-gray-900 dark:text-white" data-id="element-11660">
                        {{
                        purchase_success: 'Purchase Success',
                        purchase_decline: 'Purchase Decline',
                        exit_intent: 'Exit Intent',
                        ritual_complete: 'Ritual Complete',
                        content_unlock: 'Content Unlock',
                        session_timeout: 'Session Timeout'
                      }[offer.triggerId] || offer.triggerId}
                      </p>
                    </div>
                    <div data-id="element-11661">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11662">
                        Placement Type
                      </h4>
                      <p className="mt-1 text-sm text-gray-900 dark:text-white" data-id="element-11663">
                        {{
                        full_screen_modal: 'Full Screen Modal',
                        bottom_sheet: 'Bottom Sheet',
                        toast_with_cta: 'Toast with CTA',
                        interstitial: 'Interstitial'
                      }[offer.placementId] || offer.placementId}
                      </p>
                    </div>
                    <div data-id="element-11664">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11665">
                        Description
                      </h4>
                      <p className="mt-1 text-sm text-gray-900 dark:text-white" data-id="element-11666">
                        {offer.description}
                      </p>
                    </div>
                    <div data-id="element-11667">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11668">
                        {offer.offerSource.type === 'internal' ? 'Product' : 'Partner'}
                      </h4>
                      <p className="mt-1 text-sm text-gray-900 dark:text-white" data-id="element-11669">
                        {offer.offerSource.type === 'internal' ? offer.offerSource.productName : offer.offerSource.partnerName}
                      </p>
                    </div>
                    <div data-id="element-11670">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11671">
                        {offer.offerSource.type === 'internal' ? 'Pricing' : 'Payout'}
                      </h4>
                      <p className="mt-1 text-sm text-gray-900 dark:text-white" data-id="element-11672">
                        {offer.offerSource.type === 'internal' ? <span data-id="element-11673">
                            <span className="line-through text-gray-500 dark:text-gray-400 mr-2" data-id="element-11674">
                              ${offer.offerSource.regularPrice.toFixed(2)}
                            </span>
                            <span className="font-medium" data-id="element-11675">
                              ${offer.offerSource.discountedPrice.toFixed(2)}
                            </span>{' '}
                            <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-11676">
                              ({offer.offerSource.discountPercentage}% off)
                            </span>
                          </span> : <span data-id="element-11677">
                            ${offer.offerSource.payoutAmount.toFixed(2)}{' '}
                            <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-11678">
                              (
                              {offer.offerSource.payoutModelId === 'cpa' ? 'CPA' : offer.offerSource.payoutModelId === 'cps' ? 'CPS' : 'RevShare'}
                              )
                            </span>
                          </span>}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-5" data-id="element-11679">
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-11680">
                    Performance Summary
                  </h3>
                  <div className="grid grid-cols-2 gap-4" data-id="element-11681">
                    <div data-id="element-11682">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11683">
                        Triggered
                      </h4>
                      <p className="mt-1 text-xl font-semibold text-gray-900 dark:text-white" data-id="element-11684">
                        {offer.performance.triggered.toLocaleString()}
                      </p>
                    </div>
                    <div data-id="element-11685">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11686">
                        Viewed
                      </h4>
                      <p className="mt-1 text-xl font-semibold text-gray-900 dark:text-white" data-id="element-11687">
                        {offer.performance.viewed.toLocaleString()}
                      </p>
                    </div>
                    <div data-id="element-11688">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11689">
                        Clicked
                      </h4>
                      <p className="mt-1 text-xl font-semibold text-gray-900 dark:text-white" data-id="element-11690">
                        {offer.performance.clicked.toLocaleString()}
                      </p>
                    </div>
                    <div data-id="element-11691">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11692">
                        Converted
                      </h4>
                      <p className="mt-1 text-xl font-semibold text-gray-900 dark:text-white" data-id="element-11693">
                        {offer.performance.converted.toLocaleString()}
                      </p>
                    </div>
                    <div data-id="element-11694">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11695">
                        Revenue
                      </h4>
                      <p className="mt-1 text-xl font-semibold text-gray-900 dark:text-white" data-id="element-11696">
                        ${offer.performance.revenue.toLocaleString()}
                      </p>
                    </div>
                    <div data-id="element-11697">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11698">
                        RPM
                      </h4>
                      <p className="mt-1 text-xl font-semibold text-gray-900 dark:text-white" data-id="element-11699">
                        ${offer.performance.rpm.toFixed(2)}
                      </p>
                    </div>
                    <div data-id="element-11700">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11701">
                        Conversion Rate
                      </h4>
                      <p className="mt-1 text-xl font-semibold text-gray-900 dark:text-white" data-id="element-11702">
                        {(offer.performance.cr * 100).toFixed(2)}%
                      </p>
                    </div>
                    <div data-id="element-11703">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11704">
                        Attach Rate
                      </h4>
                      <p className="mt-1 text-xl font-semibold text-gray-900 dark:text-white" data-id="element-11705">
                        {(offer.performance.attachRate * 100).toFixed(2)}%
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 mt-6" data-id="element-11706">
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-5" data-id="element-11707">
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-11708">
                    Lift vs. Control
                  </h3>
                  <div className="flex items-center" data-id="element-11709">
                    <div className="w-1/3 p-4 border-r border-gray-200 dark:border-gray-700" data-id="element-11710">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-11711">
                        Revenue Lift
                      </h4>
                      <p className="text-3xl font-bold text-gray-900 dark:text-white" data-id="element-11712">
                        $
                        {offer.performance.liftVsControl.revenue.toLocaleString()}
                      </p>
                    </div>
                    <div className="w-1/3 p-4 border-r border-gray-200 dark:border-gray-700" data-id="element-11713">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-11714">
                        Percentage Lift
                      </h4>
                      <p className="text-3xl font-bold text-green-600 dark:text-green-400" data-id="element-11715">
                        +{offer.performance.liftVsControl.percentage}%
                      </p>
                    </div>
                    <div className="w-1/3 p-4" data-id="element-11716">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-11717">
                        Test Result
                      </h4>
                      <p className={`text-xl font-bold ${offer.performance.liftVsControl.isWinner ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}`} data-id="element-11718">
                        {offer.performance.liftVsControl.isWinner ? 'WINNER' : 'LOSER'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </TabsContent>
            <TabsContent value="performance" className="pt-6" data-id="element-11719">
              <div className="grid grid-cols-1 gap-6" data-id="element-11720">
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-5" data-id="element-11721">
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-11722">
                    Performance Funnel
                  </h3>
                  <div className="flex justify-around items-end h-64" data-id="element-11723">
                    <div className="flex flex-col items-center" data-id="element-11724">
                      <div className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-11725">
                        Triggered
                      </div>
                      <div className="w-20 bg-purple-600 dark:bg-purple-500" style={{
                      height: '200px'
                    }} data-id="element-11726"></div>
                      <div className="mt-2 text-lg font-semibold text-gray-900 dark:text-white" data-id="element-11727">
                        {offer.performance.triggered.toLocaleString()}
                      </div>
                      <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-11728">
                        100%
                      </div>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-11729">
                      <div className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-11730">
                        Viewed
                      </div>
                      <div className="w-20 bg-blue-600 dark:bg-blue-500" style={{
                      height: `${offer.performance.viewed / offer.performance.triggered * 200}px`
                    }} data-id="element-11731"></div>
                      <div className="mt-2 text-lg font-semibold text-gray-900 dark:text-white" data-id="element-11732">
                        {offer.performance.viewed.toLocaleString()}
                      </div>
                      <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-11733">
                        {(offer.performance.viewed / offer.performance.triggered * 100).toFixed(1)}
                        %
                      </div>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-11734">
                      <div className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-11735">
                        Clicked
                      </div>
                      <div className="w-20 bg-green-600 dark:bg-green-500" style={{
                      height: `${offer.performance.clicked / offer.performance.triggered * 200}px`
                    }} data-id="element-11736"></div>
                      <div className="mt-2 text-lg font-semibold text-gray-900 dark:text-white" data-id="element-11737">
                        {offer.performance.clicked.toLocaleString()}
                      </div>
                      <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-11738">
                        {(offer.performance.clicked / offer.performance.triggered * 100).toFixed(1)}
                        %
                      </div>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-11739">
                      <div className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-11740">
                        Converted
                      </div>
                      <div className="w-20 bg-yellow-600 dark:bg-yellow-500" style={{
                      height: `${offer.performance.converted / offer.performance.triggered * 200}px`
                    }} data-id="element-11741"></div>
                      <div className="mt-2 text-lg font-semibold text-gray-900 dark:text-white" data-id="element-11742">
                        {offer.performance.converted.toLocaleString()}
                      </div>
                      <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-11743">
                        {(offer.performance.converted / offer.performance.triggered * 100).toFixed(1)}
                        %
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-5" data-id="element-11744">
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-11745">
                    Performance Metrics
                  </h3>
                  <div className="overflow-x-auto" data-id="element-11746">
                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700" data-id="element-11747">
                      <thead className="bg-gray-50 dark:bg-gray-800" data-id="element-11748">
                        <tr data-id="element-11749">
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-11750">
                            Metric
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-11751">
                            Value
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-11752">
                            Benchmark
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-11753">
                            Performance
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" data-id="element-11754">
                        <tr data-id="element-11755">
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-11756">
                            View Rate
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white" data-id="element-11757">
                            {(offer.performance.viewed / offer.performance.triggered * 100).toFixed(2)}
                            %
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-11758">
                            85.00%
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-11759">
                            <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${offer.performance.viewed / offer.performance.triggered > 0.85 ? 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-400' : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-400'}`} data-id="element-11760">
                              {offer.performance.viewed / offer.performance.triggered > 0.85 ? 'Above Average' : 'Below Average'}
                            </span>
                          </td>
                        </tr>
                        <tr data-id="element-11761">
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-11762">
                            Click-Through Rate
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white" data-id="element-11763">
                            {(offer.performance.clicked / offer.performance.viewed * 100).toFixed(2)}
                            %
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-11764">
                            15.00%
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-11765">
                            <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${offer.performance.clicked / offer.performance.viewed > 0.15 ? 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-400' : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-400'}`} data-id="element-11766">
                              {offer.performance.clicked / offer.performance.viewed > 0.15 ? 'Above Average' : 'Below Average'}
                            </span>
                          </td>
                        </tr>
                        <tr data-id="element-11767">
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-11768">
                            Conversion Rate
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white" data-id="element-11769">
                            {(offer.performance.cr * 100).toFixed(2)}%
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-11770">
                            3.00%
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-11771">
                            <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${offer.performance.cr > 0.03 ? 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-400' : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-400'}`} data-id="element-11772">
                              {offer.performance.cr > 0.03 ? 'Above Average' : 'Below Average'}
                            </span>
                          </td>
                        </tr>
                        <tr data-id="element-11773">
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-11774">
                            RPM
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white" data-id="element-11775">
                            ${offer.performance.rpm.toFixed(2)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-11776">
                            $800.00
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-11777">
                            <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${offer.performance.rpm > 800 ? 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-400' : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-400'}`} data-id="element-11778">
                              {offer.performance.rpm > 800 ? 'Above Average' : 'Below Average'}
                            </span>
                          </td>
                        </tr>
                        <tr data-id="element-11779">
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-11780">
                            Attach Rate
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white" data-id="element-11781">
                            {(offer.performance.attachRate * 100).toFixed(2)}%
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-11782">
                            1.00%
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-11783">
                            <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${offer.performance.attachRate > 0.01 ? 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-400' : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-400'}`} data-id="element-11784">
                              {offer.performance.attachRate > 0.01 ? 'Above Average' : 'Below Average'}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </TabsContent>
            <TabsContent value="segments" className="pt-6" data-id="element-11785">
              <div className="grid grid-cols-1 gap-6" data-id="element-11786">
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-5" data-id="element-11787">
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-11788">
                    Segment Performance
                  </h3>
                  <div className="h-80" data-id="element-11789">
                    <Chart title="" data={segmentPerformanceData} type="bar" height={300} yAxisLabel="Value" colors={['#10b981', '#3b82f6', '#8b5cf6']} dataKeys={['cr', 'rpm', 'attachRate']} data-id="element-11790" />
                  </div>
                </div>
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-5" data-id="element-11791">
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-11792">
                    Segment Performance Details
                  </h3>
                  <div className="overflow-x-auto" data-id="element-11793">
                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700" data-id="element-11794">
                      <thead className="bg-gray-50 dark:bg-gray-800" data-id="element-11795">
                        <tr data-id="element-11796">
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-11797">
                            Segment
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-11798">
                            Conversion Rate
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-11799">
                            RPM
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-11800">
                            Attach Rate
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" data-id="element-11801">
                        {Object.entries(offer.performance.segmentPerformance).map(([key, value]: [string, any]) => <tr key={key} data-id="element-11802">
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-11803">
                              {key.charAt(0).toUpperCase() + key.slice(1).replace('_', ' ')}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white" data-id="element-11804">
                              {(value.cr * 100).toFixed(2)}%
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white" data-id="element-11805">
                              ${value.rpm.toFixed(2)}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white" data-id="element-11806">
                              {(value.attachRate * 100).toFixed(2)}%
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </TabsContent>
            <TabsContent value="creative" className="pt-6" data-id="element-11807">
              <div className="grid grid-cols-1 gap-6" data-id="element-11808">
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden" data-id="element-11809">
                  <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50" data-id="element-11810">
                    <h3 className="font-medium text-gray-900 dark:text-white" data-id="element-11811">
                      Creative Preview
                    </h3>
                  </div>
                  <div className="p-6" data-id="element-11812">
                    <div className="flex flex-col md:flex-row gap-6" data-id="element-11813">
                      <div className="md:w-1/3" data-id="element-11814">
                        <div className="aspect-w-16 aspect-h-9 bg-gray-100 dark:bg-gray-700 rounded-md overflow-hidden" data-id="element-11815">
                          {offer.creative.imageUrl ? <img src={offer.creative.imageUrl} alt={offer.creative.title || 'Creative image'} className="object-cover w-full h-full" data-id="element-11816" /> : <div className="flex items-center justify-center h-full" data-id="element-11817">
                              <span className="text-gray-500 dark:text-gray-400" data-id="element-11818">
                                No image available
                              </span>
                            </div>}
                        </div>
                        <div className="mt-3 flex justify-center" data-id="element-11819">
                          <button onClick={handlePreview} className="px-4 py-2 bg-purple-600 text-white rounded-md text-sm hover:bg-purple-700 transition-colors flex items-center" data-id="element-11820">
                            <Eye size={16} className="mr-2" data-id="element-11821" />
                            View Full Size
                          </button>
                        </div>
                      </div>
                      <div className="md:w-2/3" data-id="element-11822">
                        <div className="space-y-4" data-id="element-11823">
                          <div data-id="element-11824">
                            <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11825">
                              Title
                            </h4>
                            <p className="mt-1 text-lg font-semibold text-gray-900 dark:text-white" data-id="element-11826">
                              {offer.creative.title}
                            </p>
                          </div>
                          <div data-id="element-11827">
                            <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11828">
                              Copy Variants
                            </h4>
                            <div className="mt-1 space-y-3" data-id="element-11829">
                              {offer.creative.copyVariants.map((variant: string, index: number) => <div key={index} className="border border-gray-200 dark:border-gray-700 rounded-md p-3" data-id="element-11830">
                                    <div className="flex justify-between mb-2" data-id="element-11831">
                                      <span className="text-xs font-medium text-gray-500 dark:text-gray-400" data-id="element-11832">
                                        Variant {index + 1}
                                      </span>
                                      <span className="text-xs font-medium text-purple-600 dark:text-purple-400" data-id="element-11833">
                                        Weight: {offer.creative.weights[index]}%
                                      </span>
                                    </div>
                                    <p className="text-sm text-gray-900 dark:text-white" data-id="element-11834">
                                      {variant}
                                    </p>
                                  </div>)}
                            </div>
                          </div>
                          <div data-id="element-11835">
                            <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11836">
                              A/B Testing
                            </h4>
                            <p className="mt-1 text-sm text-gray-900 dark:text-white" data-id="element-11837">
                              {offer.creative.autoAB ? 'Enabled' : 'Disabled'}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden" data-id="element-11838">
                  <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50" data-id="element-11839">
                    <h3 className="font-medium text-gray-900 dark:text-white" data-id="element-11840">
                      Preview by Placement Type
                    </h3>
                  </div>
                  <div className="p-6" data-id="element-11841">
                    <div className="max-w-lg mx-auto" data-id="element-11842">
                      {offer.placementId === 'full_screen_modal' && <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden border border-gray-200 dark:border-gray-700" data-id="element-11843">
                          <div className="relative" data-id="element-11844">
                            {offer.creative.imageUrl && <img src={offer.creative.imageUrl} alt="Creative" className="w-full h-48 object-cover" data-id="element-11845" />}
                            <div className="p-6" data-id="element-11846">
                              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2" data-id="element-11847">
                                {offer.creative.title}
                              </h3>
                              <p className="text-gray-700 dark:text-gray-300 mb-4" data-id="element-11848">
                                {offer.creative.copyVariants[0]}
                              </p>
                              {offer.offerSource.type === 'internal' && <div className="flex items-center mb-4" data-id="element-11849">
                                  <span className="line-through text-gray-500 dark:text-gray-400 mr-2" data-id="element-11850">
                                    ${offer.offerSource.regularPrice.toFixed(2)}
                                  </span>
                                  <span className="text-xl font-bold text-green-600 dark:text-green-400" data-id="element-11851">
                                    $
                                    {offer.offerSource.discountedPrice.toFixed(2)}
                                  </span>
                                  {offer.offerSource.discountPercentage > 0 && <span className="ml-2 bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-400 text-xs font-semibold px-2 py-1 rounded" data-id="element-11852">
                                      {offer.offerSource.discountPercentage}%
                                      OFF
                                    </span>}
                                </div>}
                              {offer.pricingAndDiscounts.oneTimeBonus && <div className="bg-yellow-50 dark:bg-yellow-900/20 p-2 rounded mb-4" data-id="element-11853">
                                  <p className="text-sm text-yellow-800 dark:text-yellow-300" data-id="element-11854">
                                    <span className="font-bold" data-id="element-11855">Bonus:</span>{' '}
                                    {offer.pricingAndDiscounts.oneTimeBonus}
                                  </p>
                                </div>}
                              {offer.pricingAndDiscounts.countdown.enabled && <div className="bg-gray-100 dark:bg-gray-700 p-2 rounded-md mb-4" data-id="element-11856">
                                  <p className="text-sm text-gray-700 dark:text-gray-300 text-center" data-id="element-11857">
                                    Offer expires in:{' '}
                                    <span className="font-bold" data-id="element-11858">
                                      {offer.pricingAndDiscounts.countdown.minutes}
                                      :00
                                    </span>
                                  </p>
                                </div>}
                              <div className="flex space-x-3" data-id="element-11859">
                                <button className="flex-1 bg-purple-600 text-white py-2 px-4 rounded hover:bg-purple-700 transition-colors" data-id="element-11860">
                                  Get This Offer
                                </button>
                                <button className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors" data-id="element-11861">
                                  No Thanks
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>}
                      {offer.placementId === 'bottom_sheet' && <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden border border-gray-200 dark:border-gray-700" data-id="element-11862">
                          <div className="p-4" data-id="element-11863">
                            <div className="flex items-center mb-3" data-id="element-11864">
                              {offer.creative.imageUrl && <img src={offer.creative.imageUrl} alt="Creative" className="w-16 h-16 object-cover rounded-md mr-4" data-id="element-11865" />}
                              <div data-id="element-11866">
                                <h3 className="text-lg font-bold text-gray-900 dark:text-white" data-id="element-11867">
                                  {offer.creative.title}
                                </h3>
                                {offer.offerSource.type === 'internal' && <div className="flex items-center" data-id="element-11868">
                                    <span className="line-through text-gray-500 dark:text-gray-400 text-sm mr-2" data-id="element-11869">
                                      $
                                      {offer.offerSource.regularPrice.toFixed(2)}
                                    </span>
                                    <span className="text-green-600 dark:text-green-400 font-bold" data-id="element-11870">
                                      $
                                      {offer.offerSource.discountedPrice.toFixed(2)}
                                    </span>
                                  </div>}
                              </div>
                            </div>
                            <p className="text-gray-700 dark:text-gray-300 text-sm mb-3" data-id="element-11871">
                              {offer.creative.copyVariants[0]}
                            </p>
                            <div className="flex space-x-2" data-id="element-11872">
                              <button className="flex-1 bg-purple-600 text-white py-2 px-3 rounded text-sm hover:bg-purple-700 transition-colors" data-id="element-11873">
                                Get Offer
                              </button>
                              <button className="px-3 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded text-sm hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors" data-id="element-11874">
                                Dismiss
                              </button>
                            </div>
                          </div>
                        </div>}
                      {offer.placementId === 'toast_with_cta' && <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden border border-gray-200 dark:border-gray-700" data-id="element-11875">
                          <div className="p-3 flex items-center" data-id="element-11876">
                            {offer.creative.imageUrl && <img src={offer.creative.imageUrl} alt="Creative" className="w-10 h-10 object-cover rounded-md mr-3" data-id="element-11877" />}
                            <div className="flex-1" data-id="element-11878">
                              <h3 className="text-sm font-bold text-gray-900 dark:text-white" data-id="element-11879">
                                {offer.creative.title}
                              </h3>
                              <p className="text-xs text-gray-700 dark:text-gray-300" data-id="element-11880">
                                {offer.creative.copyVariants[0]}
                              </p>
                            </div>
                            <button className="ml-2 bg-purple-600 text-white py-1 px-2 rounded text-xs hover:bg-purple-700 transition-colors" data-id="element-11881">
                              View
                            </button>
                          </div>
                        </div>}
                      {offer.placementId === 'interstitial' && <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden border border-gray-200 dark:border-gray-700" data-id="element-11882">
                          <div className="relative" data-id="element-11883">
                            {offer.creative.imageUrl && <img src={offer.creative.imageUrl} alt="Creative" className="w-full h-64 object-cover" data-id="element-11884" />}
                            <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-center p-6" data-id="element-11885">
                              <h3 className="text-xl font-bold text-white mb-2" data-id="element-11886">
                                {offer.creative.title}
                              </h3>
                              <p className="text-white text-center mb-4 max-w-md" data-id="element-11887">
                                {offer.creative.copyVariants[0]}
                              </p>
                              <div className="flex space-x-3" data-id="element-11888">
                                <button className="bg-purple-600 text-white py-2 px-4 rounded hover:bg-purple-700 transition-colors" data-id="element-11889">
                                  Get Offer
                                </button>
                                <button className="bg-gray-800 bg-opacity-50 text-white py-2 px-4 rounded hover:bg-gray-700 transition-colors" data-id="element-11890">
                                  Continue
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>}
                    </div>
                  </div>
                </div>
              </div>
            </TabsContent>
            <TabsContent value="settings" className="pt-6" data-id="element-11891">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-11892">
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-5" data-id="element-11893">
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-11894">
                    Targeting Settings
                  </h3>
                  <div className="space-y-4" data-id="element-11895">
                    <div data-id="element-11896">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11897">
                        Target Segments
                      </h4>
                      <div className="mt-1 flex flex-wrap gap-1" data-id="element-11898">
                        {offer.targeting.segments.map((segment: string) => <span key={segment} className="px-2 py-1 text-xs bg-indigo-100 text-indigo-800 dark:bg-indigo-900/20 dark:text-indigo-400 rounded" data-id="element-11899">
                            {segment.split('_').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                          </span>)}
                      </div>
                    </div>
                    <div data-id="element-11900">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11901">
                        Fallback Strategy
                      </h4>
                      <p className="mt-1 text-sm text-gray-900 dark:text-white" data-id="element-11902">
                        {offer.targeting.fallbackType.charAt(0).toUpperCase() + offer.targeting.fallbackType.slice(1)}
                      </p>
                    </div>
                    <div data-id="element-11903">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11904">
                        GEOs
                      </h4>
                      <div className="mt-1 flex flex-wrap gap-1" data-id="element-11905">
                        {offer.targeting.geos.map((geo: string) => <span key={geo} className="px-2 py-1 text-xs bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-400 rounded" data-id="element-11906">
                            {geo.toUpperCase()}
                          </span>)}
                      </div>
                    </div>
                    <div data-id="element-11907">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11908">
                        Devices
                      </h4>
                      <div className="mt-1 flex flex-wrap gap-1" data-id="element-11909">
                        {offer.targeting.devices.map((device: string) => <span key={device} className="px-2 py-1 text-xs bg-purple-100 text-purple-800 dark:bg-purple-900/20 dark:text-purple-400 rounded" data-id="element-11910">
                            {device.charAt(0).toUpperCase() + device.slice(1)}
                          </span>)}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-5" data-id="element-11911">
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-11912">
                    Pricing & Discounts
                  </h3>
                  <div className="space-y-4" data-id="element-11913">
                    <div data-id="element-11914">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11915">
                        Dynamic Incentives
                      </h4>
                      <p className="mt-1 text-sm text-gray-900 dark:text-white" data-id="element-11916">
                        {offer.pricingAndDiscounts.dynamicIncentives ? 'Enabled' : 'Disabled'}
                      </p>
                    </div>
                    {offer.pricingAndDiscounts.oneTimeBonus && <div data-id="element-11917">
                        <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11918">
                          One-Time Bonus
                        </h4>
                        <p className="mt-1 text-sm text-gray-900 dark:text-white" data-id="element-11919">
                          {offer.pricingAndDiscounts.oneTimeBonus}
                        </p>
                      </div>}
                    <div data-id="element-11920">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11921">
                        Countdown Timer
                      </h4>
                      <p className="mt-1 text-sm text-gray-900 dark:text-white" data-id="element-11922">
                        {offer.pricingAndDiscounts.countdown.enabled ? `${offer.pricingAndDiscounts.countdown.minutes} minutes` : 'Disabled'}
                      </p>
                    </div>
                    {offer.offerSource.type === 'internal' && <div data-id="element-11923">
                        <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11924">
                          Pricing
                        </h4>
                        <div className="mt-1 flex items-center" data-id="element-11925">
                          <span className="line-through text-sm text-gray-500 dark:text-gray-400 mr-2" data-id="element-11926">
                            ${offer.offerSource.regularPrice.toFixed(2)}
                          </span>
                          <span className="text-sm font-medium text-gray-900 dark:text-white mr-2" data-id="element-11927">
                            ${offer.offerSource.discountedPrice.toFixed(2)}
                          </span>
                          <span className="text-xs bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-400 px-2 py-0.5 rounded" data-id="element-11928">
                            {offer.offerSource.discountPercentage}% OFF
                          </span>
                        </div>
                      </div>}
                  </div>
                </div>
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-5" data-id="element-11929">
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-11930">
                    Frequency Caps
                  </h3>
                  <div className="space-y-4" data-id="element-11931">
                    <div data-id="element-11932">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11933">
                        Frequency Cap Type
                      </h4>
                      <p className="mt-1 text-sm text-gray-900 dark:text-white" data-id="element-11934">
                        {offer.frequencyCaps.typeId.replace('_', ' ')}
                      </p>
                    </div>
                    <div data-id="element-11935">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11936">
                        Maximum Show Count
                      </h4>
                      <p className="mt-1 text-sm text-gray-900 dark:text-white" data-id="element-11937">
                        {offer.frequencyCaps.value}
                      </p>
                    </div>
                    <div data-id="element-11938">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11939">
                        Don't Show After Views
                      </h4>
                      <p className="mt-1 text-sm text-gray-900 dark:text-white" data-id="element-11940">
                        {offer.frequencyCaps.dontShowAfterViews}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-5" data-id="element-11941">
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-11942">
                    Tracking
                  </h3>
                  <div className="space-y-4" data-id="element-11943">
                    <div data-id="element-11944">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11945">
                        Click ID Macro
                      </h4>
                      <p className="mt-1 text-sm text-gray-900 dark:text-white" data-id="element-11946">
                        {offer.tracking.clickId}
                      </p>
                    </div>
                    <div data-id="element-11947">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11948">
                        Sub ID Macro
                      </h4>
                      <p className="mt-1 text-sm text-gray-900 dark:text-white" data-id="element-11949">
                        {offer.tracking.subid}
                      </p>
                    </div>
                    <div data-id="element-11950">
                      <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-11951">
                        Postback URL
                      </h4>
                      <p className="mt-1 text-sm text-gray-900 dark:text-white break-all" data-id="element-11952">
                        {offer.tracking.postbackUrl}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </div>;
};